const METRIC_TYPES = {
    initial: 'initial',
    fetch: 'fetch',
    error: 'error',
    gigPageInitial: 'gig_page_initial',
};

module.exports = {
    METRIC_TYPES,
    COUNTRY: 'country',
    DEFAULT_REVIEWS_SORT: 'relevant',
    LOCAL_REVIEW_SORT: 'local_reviews',
    DEFAULT_REVIEWS_LIMIT: 5,
    MOBILE_WEB_EXPERIMENT_LIMIT: 3,
};
